export const API_PATH = '/teslaaccount/oxp-bff-api';
export const TAX_REFUND_API_PATH = '/teslaaccount/tax-refund/api';
export const CAR_ACCESS_SUPPORT_PATH = '/support/account-support#car-access';
export const CHARGING_PAY_PATH = '/teslaaccount/charging/pay';
export const DRIVER_ACCESS_PATH = '/teslaaccount/driver-access';
export const E_SIGN_DOCUMENT_PATH = '/teslaaccount/ownership/financing/api/cosign-document';
export const ENERGY_DESIGN_PATH = '/energy/design';
export const ENERGY_PROFILE_PATH = '/teslaaccount/energy/profile?en=##EN##';
export const FINANCING_API_PATH = '/teslaaccount/ownership/financing/api';
export const LOOTBOX_PATH = '/support/referral-program';
export const PAY_NOW_PATH = '/##MODEL##/processpayment/##RN##';
export const PREVIOUSLY_OWNED_PATH = '/teslaaccount/ownership/previously-owned';
export const SEMI_ORDER_PATH = '/teslaaccount/profile?rn=##RN##';
export const SHOP_PATH = '/orders?redirect=no&signIn=true';
export const TESLAACCOUNT_PATH = '/teslaaccount';
export const THIRD_PARTY_LEARN_MORE_PATH = '/support/account-support#add-remove-products';
export const VEHICLE_DETAILS_PATH = '/teslaaccount/ownership?rn=##RN##';
export const VEHICLE_PROFILE_PATH = '/teslaaccount/profile?rn=##RN##';
export const VEHICLE_ORDER_PATH = '/teslaaccount/order/##RN##';
export const VEHICLE_UPGRADES_PATH = '/teslaaccount/ownership/upgrades?rn=##RN##';

export const NON_NAV_PAGES = {
  CONFIRMATION: '/confirmation',
  DRIVER_ACCESS: '/driver-access',
  E_SIGN: '/e-sign',
  TAX_REFUND: '/tax-refund/:vin',
};

const AUTH_SIGNER_PATH = '/teslaaccount/##RN##/authorized-signer';
const AGREEMENT_PATH = '/teslaaccount/##RN##/agreement';
const ID_VALIDATION_PATH = '/teslaaccount/##RN##/id-validation';
const ID_VERIFICATION_PATH = '/teslaaccount/##RN##/id-verification';
const LEASE_EXTENSION_PATH = '/e-sign';

export const TILES = {
  DRIVER_ACCESS: 'DRIVER_ACCESS',
  DRIVER_ACCESS_CAR: 'DRIVER_ACCESS_CAR',
  ENERGY_PRODUCT: 'ENERGY_PRODUCT',
  ENTERPRISE_DRIVER_ORDER: 'ENTERPRISE_DRIVER_ORDER',
  IN_PROGRESS: 'IN_PROGRESS',
  PREVIOUSLY_OWNED: 'PREVIOUSLY_OWNED',
  SEMI: 'SEMI',
  SHOP: 'SHOP',
  SOLAR_MARKETING: 'SOLAR_MARKETING',
  THIRD_PARTY: 'THIRD_PARTY',
  VEHICLE: 'VEHICLE',
  VEHICLE_MARKETING: 'VEHICLE_MARKETING',
};

export const ORDER_STATUS = {
  IN_PROGRESS: 'IN_PROGRESS',
  PAYMENT_PENDING: 'PAYMENT_PENDING',
  PAYMENT_REQUIRED: 'PAYMENT_REQUIRED',
  RESERVED: 'RESERVED',
};

export const MODEL_CODE = {
  ct: 'ct',
  m3: 'm3',
  mp: 'mp',
  ms: 'ms',
  mt: 'mt',
  mx: 'mx',
  my: 'my',
  rd: 'rd',
};

export const MODEL_MAPPING = {
  ct: 'Cybertruck',
  m3: 'Model 3',
  mp: 'Cybertruck',
  ms: 'Model S',
  mt: 'Roadster',
  mx: 'Model X',
  my: 'Model Y',
  rd: 'Roadster',
};

// Roadster (mt) trims returned by the BFF as vehicleInfo.roadsterTrim
export const ROADSTER_TRIM = {
  PERF: 'PERF',
  THRUST: 'THRUST',
  STANDARD: 'STANDARD',
};

// CN trims that get the Roadster card. Anything else is the legacy card.
export const CN_ROADSTER_SUPPORTED_TRIMS = [
  ROADSTER_TRIM.PERF,
  ROADSTER_TRIM.STANDARD,
  ROADSTER_TRIM.THRUST,
];

export const ENERGY_PRODUCT_TYPE = {
  HOMECHARGING: 'homeCharging',
  POWERWALL: 'powerwall',
  PVPW: 'solarPanels',
  SOLARPANELS: 'solarPanels',
  SOLARROOF: 'solarRoof',
};

export const ESIGN_STATUS_TYPES = {
  LEASE_EXTENSION: 'LEASE_EXTENSION',
  PENDING_COSIGNER: 'PENDING_COSIGNER',
  PENDING_ID_VALIDATION: 'PENDING_ID_VALIDATION',
  PENDING_ID_VERIFICATION: 'PENDING_ID_VERIFICATION',
  PENDING_SIGNER_ACCEPTANCE: 'PENDING_SIGNER_ACCEPTANCE',
  DISABLED: 'DISABLED',
  VERIFIED: 'VERIFIED',
};

export const ESIGN_PATH_MAP = {
  PENDING_COSIGNER: AGREEMENT_PATH,
  PENDING_ID_VALIDATION: ID_VALIDATION_PATH,
  PENDING_ID_VERIFICATION: ID_VERIFICATION_PATH,
  PENDING_SIGNER_ACCEPTANCE: AUTH_SIGNER_PATH,
  VERIFIED: AUTH_SIGNER_PATH,
  DISABLED: '/',
};

export const INTERNAL_ESIGN_MAP = {
  LEASE_EXTENSION: LEASE_EXTENSION_PATH,
};

export const LOCALES = {
  EN_US: 'en_US',
  EN_AU: 'en_au',
  ZH_CN: 'zh_CN',
};

export const COUNTRIES = {
  US: 'US',
};

export const ENVIRONMENT = {
  LOCAL: 'localDev',
  DEVELOPMENT: 'development',
};

export const GA_OPTIONS = {
  ACCOUNT: 'account',
  ACCOUNT_TYPE: 'account-type',
  DASHBOARD: 'dashboard',
  DRIVER_ACCESS: 'driver-access',
  ENERGY_CARD_SHOWN: 'energy-card-shown',
  ENERGY_CROSS_SELL: 'energy-cross-sell',
  LEARN_MORE: 'learn-more',
  MANAGE: 'manage',
  ORDER_HISTORY: 'order-history',
  ORDER_SOLARROOF: 'order-solarroof',
  ORDER_VEHICLE: 'order-vehicle',
  PREVIOUSLY_OWNED: 'previously-owned',
  PREVIOUSLY_OWNED_CARD: 'previously-owned-card-shown',
  SEMI: 'semi',
  THIRD_PARTY: 'third-party',
  VEHICLE_CARD_SHOWN: 'vehicle-card-shown',
  VEHICLE_CROSS_SELL: 'vehicle-cross-sell',
  VIEW_SHOP_TXNS: 'view-shop-transactions',
};

export const E_SIGN_PACKET_TYPES = {
  DMV: 'DMV',
  LEASE_EXTENSION: 'LEASE_EXTENSION',
  LEASING: 'LEASING',
  LENDING: 'LENDING',
};

export const E_SIGN_DOCUMENT_TYPES = {
  ESIGN_CONSENT: 'ESIGN_CONSENT',
  CONTRACT: 'CONTRACT',
  CREDIT_APPLICATION: 'CREDIT_APPLICATION',
  LEASE_EXTENSION_CONTRACT: 'LEASE_EXTENSION_CONTRACT',
};

export const E_SIGN_DOCUMENT_LIST = {
  [E_SIGN_PACKET_TYPES.LEASE_EXTENSION]: [
    { label: 'teslaESignConsent', docType: E_SIGN_DOCUMENT_TYPES.ESIGN_CONSENT },
    { label: 'leasingExtensionAgreement', docType: E_SIGN_DOCUMENT_TYPES.LEASE_EXTENSION_CONTRACT },
  ],
};

export const FINANCING_ACTION_NAMES = {
  EXTENSION: 'EXTENSION',
  LEASE_TRANSFER: 'LEASE_TRANSFER',
  BUYOUT: 'BUYOUT',
  EARLY_LEASE_TERMINATION: 'EARLY_LEASE_TERMINATION',
  THIRDPARTY_BUYOUT: 'THIRDPARTY_BUYOUT',
  TOTAL_LOSS: 'TOTAL_LOSS',
  LEASE_END: 'LEASE_END',
  PAYMENT: 'PAYMENT',
};

export const FINANCING_URL_ENUMS = {
  EXTENSION: 'extension',
  LEASE_TRANSFER: 'leasetransfer',
  BUYOUT: 'buyout',
  EARLY_LEASE_TERMINATION: 'earlyleasetermination',
  THIRDPARTY_BUYOUT: 'thirdpartybuyout',
  TOTAL_LOSS: 'totalloss',
  LEASE_END: 'leaseend',
};

export const CGS_SIGNATURE_ROLES = {
  BUYER: 'Buyer',
  CO_BUYER: 'CoBuyer',
};
